import forms from '@/libs/forms';

const phoneField = forms.phone('Phone', 'phone', true);
phoneField.placeholder = 'Phone of contact at Escrow company';


export default {
  schema: {
    fields: [
      forms.date('What is your Close of Escrow date?', null, 'closeDate', true),
      forms.simpleInput('text', 'Escrow Company', null, 'company', true),
      forms.simpleInput('text', 'Contact Name', 'Contact at Escrow company', 'contactName', true),
      phoneField,
      forms.email('Email', 'email', 'Email of contact at Escrow company', true),
    ],
  },
  options: forms.options('payoff-form-', true),
};



// WEBPACK FOOTER //
// ./src/components/my_deals/actions/payoff/resources/schema.js